import { useMemo } from 'react';
import { useSearchRequestId } from '~/contexts/InventoryContext';

export default function useNativeVDPPayload(vehicleId?: number) {
  const searchRequestId = useSearchRequestId();

  return useMemo(
    () =>
      JSON.stringify({
        action: 'view-vdp',
        searchRequestId,
        vehicleId
      }),
    [searchRequestId, vehicleId]
  );
}
